import { Autocomplete, Button, IconButton, Select } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  backgroundSvg: {
    position: 'absolute', // Base SVG stays in place
    margin: 'auto',
    inset: 0,
    borderRadius: '100%',
    zIndex: '1', // Lower layer    
    '&.animated': {
      animation: '$pulseOrange 1s infinite linear',
    },
    '&.loading': {
      animation: '$loadingPulse 1.5s infinite linear',
    },
    boxShadow: '0 0 0 0 rgba(0, 0, 0, 1)',
    transform: 'scale(1)'
  },
  "@keyframes loadingPulse": {
    "0%": {
      transform: 'scale(0.95)',
      opacity: 0.85,
    },
    "50%": {
      transform: 'scale(1.05)',
      opacity: 1,
    },
    "100%": {
      transform: 'scale(0.95)',
      opacity: 0.85,
    },
  },
  '@keyframes pulseOrange': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(255, 121, 63, 0.8), 0 0 0 0 rgba(255, 121, 63, 0.5), 0 0 0 0 rgba(255, 121, 63, 0.3)',
      //transform: 'scale(0.98)'
    },
    '100%': {
      boxShadow: '0 0 0 15px rgba(255, 121, 63, 0.2), 0 0 0 30px rgba(255, 121, 63, 0), 0 0 0 45px rgba(255, 121, 63, 0)',
      transform: 'scale(1)'
    },

  },
  bubbleSvg: {
    position: 'absolute',
    margin: 'auto',
    inset: 0,
    zIndex: '2', // Higher layer (on top)
    '&.animated': {
      animation: '$talkingBubble 5s infinite linear',
    }
  },
  portraitSvg: {
    position: 'absolute',
    margin: 'auto',
    inset: 0,
    borderRadius: '100%',
    zIndex: '3',
    '&.animated': {
      animation: '$talkingPortrait 5s infinite linear',
    }
  },
  '@keyframes talkingPortrait': {
    '0%': {
      transform: 'scale(1)',
    },
    '6.67%': {
      transform: 'scale(1.03)',
    },
    '13.34%': {
      transform: 'scale(0.94)',
    },
    '20%': {
      transform: 'scale(1.02)',
    },
    '26.67%': {
      transform: 'scale(0.95)',
    },
    '33.34%': {
      transform: 'scale(1.01)',
    },
    '40%': {
      transform: 'scale(0.97)',
    },
    '46.67%': {
      transform: 'scale(1.04)',
    },
    '53.34%': {
      transform: 'scale(0.95)',
    },
    '60%': {
      transform: 'scale(1.02)',
    },
    '66.67%': {
      transform: 'scale(0.98)',
    },
    '73.34%': {
      transform: 'scale(1.04)',
    },
    '80%': {
      transform: 'scale(0.94)',
    },
    '86.67%': {
      transform: 'scale(1.03)',
    },
    '93.34%': {
      transform: 'scale(0.95)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
  '@keyframes talkingBubble': {
    '0%': {
      transform: 'rotate(0deg) scale(1)',
    },
    '6.67%': {
      transform: 'rotate(30deg) scale(1.03)',
    },
    '13.34%': {
      transform: 'rotate(60deg) scale(0.97)',
    },
    '20%': {
      transform: 'rotate(90deg) scale(1.04)',
    },
    '26.67%': {
      transform: 'rotate(120deg) scale(0.95)',
    },
    '33.34%': {
      transform: 'rotate(150deg) scale(1.06)',
    },
    '40%': {
      transform: 'rotate(180deg) scale(0.94)',
    },
    '46.67%': {
      transform: 'rotate(210deg) scale(1.03)',
    },
    '53.34%': {
      transform: 'rotate(240deg) scale(0.95)',
    },
    '60%': {
      transform: 'rotate(270deg) scale(1.04)',
    },
    '66.67%': {
      transform: 'rotate(300deg) scale(0.98)',
    },
    '73.34%': {
      transform: 'rotate(330deg) scale(1.05)',
    },
    '80%': {
      transform: 'rotate(360deg) scale(0.96)',
    },
    '86.67%': {
      transform: 'rotate(390deg) scale(1.03)',
    },
    '93.34%': {
      transform: 'rotate(420deg) scale(0.95)',
    },
    '100%': {
      transform: 'rotate(450deg) scale(1)',
    },
  },
}));


export default useStyles; 